export default "__VITE_ASSET__CdOqZPLF__"